<template>
  <div class="b2fa">
    <!-- {{country}} -->
    <b-input-group :size="size ? size : null">
      <b-input-group-prepend
        :id="disabled ? null : 'popover-countries-' + label"
      >
        <div :class="disabled ? 'countrydisabled' : 'countryselected'">
          <div v-if="country">
            <small class="text-muted" :title="country.code">Country</small>
            <span
              v-if="!noflags"
              :class="
                country.code
                  ? 'flag-icon flag-icon-' + country.code.toLowerCase()
                  : ''
              "
              :title="country.name ? country.name : country.code"
            ></span>
            <span class="countryprefix" v-else>{{ country.prefix }}</span>
          </div>
        </div>
        <b-popover
          v-if="!disabled"
          :target="'popover-countries-' + label"
          triggers="click"
          placement="auto"
          container="countryContainer"
          ref="popover"
          :show.sync="countriesPopover"
          :custom-class="
            darkmode ? 'countryContainer c-dark-theme' : 'countryContainer'
          "
        >
          <div>
            <b-row align-h="between" class="p-1" no-gutters>
              <b-col cols="10">
                <b-input-group>
                  <b-form-input
                    size="sm"
                    v-model="find"
                    placeholder="Find"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      style="width: auto"
                      variant="outline-danger"
                      :disabled="!find"
                      @click="find = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col cols="2">
                <b-button
                  class="float-right"
                  size="sm"
                  variant="light"
                  @click="countriesPopover = false"
                >
                  <i class="fa fa-remove"></i>
                </b-button>
              </b-col>
            </b-row>
            <b-table
              :fields="fields"
              :items="items"
              :filter="find"
              sticky-header
              selectable
              select-mode="single"
              selected-variant="primary"
              @row-selected="countrySelected"
            >
              <template v-slot:cell(icon)="row">
                <span :class="row.item.icon"></span>
              </template>
            </b-table>
          </div>
        </b-popover>
      </b-input-group-prepend>
      <b-form-input
        v-if="!disabled"
        type="text"
        :style="pinrequired ? 'border-radius:0;' : 'border-radius:0 5px 5px 0;'"
        :placeholder="placeholder ? placeholder : ''"
        :value="value ? value.replace(/\s/g, '') : null"
        :state="number_state"
        @paste.prevent
        @input="updateNumber"
        @keypress="isNumber"
      />
      <b-form-input
        v-if="disabled"
        :style="pinrequired ? 'border-radius:0;' : 'border-radius:0 5px 5px 0;'"
        type="text"
        :disabled="disabled"
        :value="hashed ? hashedMobile : value.replace(/\s/g, '')"
        :state="number_state"
      ></b-form-input>
      <b-input-group-append v-if="pinrequired">
        <b-form-input
          :id="'tooltip-checkpin' + label"
          :disabled="!number_state || !pinsent || pinverified"
          v-model="pin"
          :placeholder="pinsent ? 'Enter PIN' : 'Get PIN'"
          :maxlength="defaultOptions.pin.length ? defaultOptions.pin.length : 6"
          @keypress="isNumber"
          :size="size ? size : null"
          :class="pinerror ? 'pin error' : 'pin'"
        />

        <b-tooltip :target="'tooltip-checkpin' + label" placement="bottom"
          >Enter your {{ defaultOptions.pin.length }}-character PIN</b-tooltip
        >
        <b-button
          v-if="!pinsent && !pinverified"
          size="sm"
          title="Request PIN"
          :disabled="!number_state"
          :variant="number_state ? 'primary' : 'secondary'"
          @click="sendPIN"
        >
          <b-icon-grid3x3-gap-fill></b-icon-grid3x3-gap-fill>
        </b-button>
        <b-button
          :id="'button-checkpin' + label"
          v-if="pinsent && !pinverified"
          size="sm"
          title="Check PIN"
          variant="primary"
          @click="checkPIN"
        >
          <b-icon-play-fill></b-icon-play-fill>
        </b-button>
        <b-tooltip
          v-if="pinerror && pinsent && !pinverified"
          :show="pinerror"
          :target="'button-checkpin' + label"
          placement="top"
          variant="danger"
          >Invalid, please try again</b-tooltip
        >
        <b-button v-if="pinverified" :disabled="true" variant="success">
          <b-icon-check-square></b-icon-check-square>
        </b-button>
      </b-input-group-append>
      <b-form-invalid-feedback class="text-left"
        >{{ label ? label : "b-2fa" }}: Required</b-form-invalid-feedback
      >
    </b-input-group>
  </div>
</template>

<script>
import {
  BIconGrid3x3GapFill,
  BIconPlayFill,
  BIconCheckSquare,
} from "bootstrap-vue";

import { parsePhoneNumberFromString } from "libphonenumber-js";
import { getCountries } from "libphonenumber-js";
import { getCountryCallingCode } from "libphonenumber-js";

function dynamicSort(property) {
  var sortOrder = 1;

  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }

  return function (a, b) {
    if (sortOrder == -1) {
      return b[property].localeCompare(a[property]);
    } else {
      return a[property].localeCompare(b[property]);
    }
  };
}

export default {
  name: "b2fa",
  components: {
    BIconGrid3x3GapFill,
    BIconPlayFill,
    BIconCheckSquare,
  },
  props: {
    value: { type: String, default: "" },
    label: { type: String, default: "b2fa" },
    placeholder: { type: String, default: "" },
    size: { type: String, default: "" },
    valid: { type: Boolean, default: null },
    error: { type: Boolean, default: null },
    disabled: { type: Boolean, default: false },
    hashed: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    darkmode: { type: Boolean, default: false },
    noflags: { type: Boolean, default: false },
    pinrequired: { type: Boolean, default: false },
    pinsent: { type: Boolean, default: false },
    pinverified: { type: Boolean, default: false },
    pinerror: { type: Boolean, default: false },
  },
  data() {
    return {
      defaultOptions: {
        preferredCountries: [{ code: "GB" }],
        preferredPrefix: [
          { id: "+1", code: "US" },
          { id: "+44", code: "GB" },
          { id: "+358", code: "FI" },
        ],
        pin: {
          length: 6,
        },
        iso3166: [
          { ccode: "AF", cname: "Afghanistan" },
          { ccode: "AX", cname: "Aland Islands" },
          { ccode: "AL", cname: "Albania" },
          { ccode: "DZ", cname: "Algeria" },
          { ccode: "AS", cname: "American Samoa" },
          { ccode: "AD", cname: "Andorra" },
          { ccode: "AO", cname: "Angola" },
          { ccode: "AI", cname: "Anguilla" },
          { ccode: "AQ", cname: "Antarctica" },
          { ccode: "AG", cname: "Antigua And Barbuda" },
          { ccode: "AR", cname: "Argentina" },
          { ccode: "AM", cname: "Armenia" },
          { ccode: "AW", cname: "Aruba" },
          { ccode: "AC", cname: "Ascension Island" },
          { ccode: "AU", cname: "Australia" },
          { ccode: "AT", cname: "Austria" },
          { ccode: "AZ", cname: "Azerbaijan" },
          { ccode: "BS", cname: "Bahamas" },
          { ccode: "BH", cname: "Bahrain" },
          { ccode: "BD", cname: "Bangladesh" },
          { ccode: "BB", cname: "Barbados" },
          { ccode: "BY", cname: "Belarus" },
          { ccode: "BE", cname: "Belgium" },
          { ccode: "BZ", cname: "Belize" },
          { ccode: "BJ", cname: "Benin" },
          { ccode: "BM", cname: "Bermuda" },
          { ccode: "BT", cname: "Bhutan" },
          { ccode: "BO", cname: "Bolivia" },
          { ccode: "BQ", cname: "Bonaire, Sint Eustatius and Saba" },
          { ccode: "BA", cname: "Bosnia And Herzegovina" },
          { ccode: "BW", cname: "Botswana" },
          { ccode: "BV", cname: "Bouvet Island" },
          { ccode: "BR", cname: "Brazil" },
          { ccode: "IO", cname: "British Indian Ocean Territory" },
          { ccode: "BN", cname: "Brunei Darussalam" },
          { ccode: "BG", cname: "Bulgaria" },
          { ccode: "BF", cname: "Burkina Faso" },
          { ccode: "BI", cname: "Burundi" },
          { ccode: "KH", cname: "Cambodia" },
          { ccode: "CM", cname: "Cameroon" },
          { ccode: "CA", cname: "Canada" },
          { ccode: "CV", cname: "Cape Verde" },
          { ccode: "KY", cname: "Cayman Islands" },
          { ccode: "CF", cname: "Central African Republic" },
          { ccode: "TD", cname: "Chad" },
          { ccode: "CL", cname: "Chile" },
          { ccode: "CN", cname: "China" },
          { ccode: "CX", cname: "Christmas Island" },
          { ccode: "CC", cname: "Cocos (Keeling) Islands" },
          { ccode: "CO", cname: "Colombia" },
          { ccode: "KM", cname: "Comoros" },
          { ccode: "CG", cname: "Congo" },
          { ccode: "CD", cname: "Congo, Democratic Republic" },
          { ccode: "CK", cname: "Cook Islands" },
          { ccode: "CR", cname: "Costa Rica" },
          { ccode: "CI", cname: "Cote D'Ivoire" },
          { ccode: "HR", cname: "Croatia" },
          { ccode: "CU", cname: "Cuba" },
          { ccode: "CW", cname: "Curacao" },
          { ccode: "CY", cname: "Cyprus" },
          { ccode: "CZ", cname: "Czech Republic" },
          { ccode: "DK", cname: "Denmark" },
          { ccode: "KP", cname: "Democratic People's Republic of Korea" },
          { ccode: "DJ", cname: "Djibouti" },
          { ccode: "DM", cname: "Dominica" },
          { ccode: "DO", cname: "Dominican Republic" },
          { ccode: "EC", cname: "Ecuador" },
          { ccode: "EG", cname: "Egypt" },
          { ccode: "SV", cname: "El Salvador" },
          { ccode: "GQ", cname: "Equatorial Guinea" },
          { ccode: "ER", cname: "Eritrea" },
          { ccode: "EE", cname: "Estonia" },
          { ccode: "ET", cname: "Ethiopia" },
          { ccode: "FK", cname: "Falkland Islands (Malvinas)" },
          { ccode: "FO", cname: "Faroe Islands" },
          { ccode: "FJ", cname: "Fiji" },
          { ccode: "FI", cname: "Finland" },
          { ccode: "FR", cname: "France" },
          { ccode: "GF", cname: "French Guiana" },
          { ccode: "PF", cname: "French Polynesia" },
          { ccode: "TF", cname: "French Southern Territories" },
          { ccode: "GA", cname: "Gabon" },
          { ccode: "GM", cname: "Gambia" },
          { ccode: "GE", cname: "Georgia" },
          { ccode: "DE", cname: "Germany" },
          { ccode: "GH", cname: "Ghana" },
          { ccode: "GI", cname: "Gibraltar" },
          { ccode: "GR", cname: "Greece" },
          { ccode: "GL", cname: "Greenland" },
          { ccode: "GD", cname: "Grenada" },
          { ccode: "GP", cname: "Guadeloupe" },
          { ccode: "GU", cname: "Guam" },
          { ccode: "GT", cname: "Guatemala" },
          { ccode: "GG", cname: "Guernsey" },
          { ccode: "GN", cname: "Guinea" },
          { ccode: "GW", cname: "Guinea-Bissau" },
          { ccode: "GY", cname: "Guyana" },
          { ccode: "HT", cname: "Haiti" },
          { ccode: "HM", cname: "Heard Island & Mcdonald Islands" },
          { ccode: "VA", cname: "Holy See (Vatican City State)" },
          { ccode: "HN", cname: "Honduras" },
          { ccode: "HK", cname: "Hong Kong" },
          { ccode: "HU", cname: "Hungary" },
          { ccode: "IS", cname: "Iceland" },
          { ccode: "IN", cname: "India" },
          { ccode: "ID", cname: "Indonesia" },
          { ccode: "IR", cname: "Iran, Islamic Republic Of" },
          { ccode: "IQ", cname: "Iraq" },
          { ccode: "IE", cname: "Ireland" },
          { ccode: "IM", cname: "Isle Of Man" },
          { ccode: "IL", cname: "Israel" },
          { ccode: "IT", cname: "Italy" },
          { ccode: "JM", cname: "Jamaica" },
          { ccode: "JP", cname: "Japan" },
          { ccode: "JE", cname: "Jersey" },
          { ccode: "JO", cname: "Jordan" },
          { ccode: "KZ", cname: "Kazakhstan" },
          { ccode: "KE", cname: "Kenya" },
          { ccode: "KI", cname: "Kiribati" },
          { ccode: "KR", cname: "Korea" },
          { ccode: "XK", cname: "Kosovo" },
          { ccode: "KW", cname: "Kuwait" },
          { ccode: "KG", cname: "Kyrgyzstan" },
          { ccode: "LA", cname: "Lao People's Democratic Republic" },
          { ccode: "LV", cname: "Latvia" },
          { ccode: "LB", cname: "Lebanon" },
          { ccode: "LS", cname: "Lesotho" },
          { ccode: "LR", cname: "Liberia" },
          { ccode: "LY", cname: "Libyan Arab Jamahiriya" },
          { ccode: "LI", cname: "Liechtenstein" },
          { ccode: "LT", cname: "Lithuania" },
          { ccode: "LU", cname: "Luxembourg" },
          { ccode: "MO", cname: "Macao" },
          { ccode: "MK", cname: "Macedonia" },
          { ccode: "MG", cname: "Madagascar" },
          { ccode: "MW", cname: "Malawi" },
          { ccode: "MY", cname: "Malaysia" },
          { ccode: "MV", cname: "Maldives" },
          { ccode: "ML", cname: "Mali" },
          { ccode: "MT", cname: "Malta" },
          { ccode: "MH", cname: "Marshall Islands" },
          { ccode: "MQ", cname: "Martinique" },
          { ccode: "MR", cname: "Mauritania" },
          { ccode: "MU", cname: "Mauritius" },
          { ccode: "YT", cname: "Mayotte" },
          { ccode: "MX", cname: "Mexico" },
          { ccode: "FM", cname: "Micronesia, Federated States Of" },
          { ccode: "MD", cname: "Moldova" },
          { ccode: "MC", cname: "Monaco" },
          { ccode: "MN", cname: "Mongolia" },
          { ccode: "ME", cname: "Montenegro" },
          { ccode: "MS", cname: "Montserrat" },
          { ccode: "MA", cname: "Morocco" },
          { ccode: "MZ", cname: "Mozambique" },
          { ccode: "MM", cname: "Myanmar" },
          { ccode: "NA", cname: "Namibia" },
          { ccode: "NR", cname: "Nauru" },
          { ccode: "NP", cname: "Nepal" },
          { ccode: "NL", cname: "Netherlands" },
          { ccode: "AN", cname: "Netherlands Antilles" },
          { ccode: "NC", cname: "New Caledonia" },
          { ccode: "NZ", cname: "New Zealand" },
          { ccode: "NI", cname: "Nicaragua" },
          { ccode: "NE", cname: "Niger" },
          { ccode: "NG", cname: "Nigeria" },
          { ccode: "NU", cname: "Niue" },
          { ccode: "NF", cname: "Norfolk Island" },
          { ccode: "MP", cname: "Northern Mariana Islands" },
          { ccode: "NO", cname: "Norway" },
          { ccode: "OM", cname: "Oman" },
          { ccode: "PK", cname: "Pakistan" },
          { ccode: "PW", cname: "Palau" },
          { ccode: "PS", cname: "Palestinian Territory, Occupied" },
          { ccode: "PA", cname: "Panama" },
          { ccode: "PG", cname: "Papua New Guinea" },
          { ccode: "PY", cname: "Paraguay" },
          { ccode: "PE", cname: "Peru" },
          { ccode: "PH", cname: "Philippines" },
          { ccode: "PN", cname: "Pitcairn" },
          { ccode: "PL", cname: "Poland" },
          { ccode: "PT", cname: "Portugal" },
          { ccode: "PR", cname: "Puerto Rico" },
          { ccode: "QA", cname: "Qatar" },
          { ccode: "RE", cname: "Reunion" },
          { ccode: "RO", cname: "Romania" },
          { ccode: "RU", cname: "Russian Federation" },
          { ccode: "RW", cname: "Rwanda" },
          { ccode: "BL", cname: "Saint Barthelemy" },
          { ccode: "SH", cname: "Saint Helena" },
          { ccode: "KN", cname: "Saint Kitts And Nevis" },
          { ccode: "LC", cname: "Saint Lucia" },
          { ccode: "MF", cname: "Saint Martin" },
          { ccode: "PM", cname: "Saint Pierre And Miquelon" },
          { ccode: "VC", cname: "Saint Vincent And Grenadines" },
          { ccode: "WS", cname: "Samoa" },
          { ccode: "SM", cname: "San Marino" },
          { ccode: "ST", cname: "Sao Tome And Principe" },
          { ccode: "SA", cname: "Saudi Arabia" },
          { ccode: "SN", cname: "Senegal" },
          { ccode: "RS", cname: "Serbia" },
          { ccode: "SC", cname: "Seychelles" },
          { ccode: "SL", cname: "Sierra Leone" },
          { ccode: "SG", cname: "Singapore" },
          { ccode: "SX", cname: "Sint Maarten" },
          { ccode: "SK", cname: "Slovakia" },
          { ccode: "SI", cname: "Slovenia" },
          { ccode: "SB", cname: "Solomon Islands" },
          { ccode: "SO", cname: "Somalia" },
          { ccode: "ZA", cname: "South Africa" },
          { ccode: "GS", cname: "South Georgia And Sandwich Isl." },
          { ccode: "SS", cname: "South Sudan" },
          { ccode: "ES", cname: "Spain" },
          { ccode: "LK", cname: "Sri Lanka" },
          { ccode: "SD", cname: "Sudan" },
          { ccode: "SR", cname: "Suriname" },
          { ccode: "SJ", cname: "Svalbard And Jan Mayen" },
          { ccode: "SZ", cname: "Swaziland" },
          { ccode: "SE", cname: "Sweden" },
          { ccode: "CH", cname: "Switzerland" },
          { ccode: "SY", cname: "Syrian Arab Republic" },
          { ccode: "TW", cname: "Taiwan" },
          { ccode: "TJ", cname: "Tajikistan" },
          { ccode: "TZ", cname: "Tanzania" },
          { ccode: "TH", cname: "Thailand" },
          { ccode: "TL", cname: "Timor-Leste" },
          { ccode: "TG", cname: "Togo" },
          { ccode: "TK", cname: "Tokelau" },
          { ccode: "TO", cname: "Tonga" },
          { ccode: "TT", cname: "Trinidad And Tobago" },
          { ccode: "TA", cname: "Tristan da Cunha" },
          { ccode: "TN", cname: "Tunisia" },
          { ccode: "TR", cname: "Turkey" },
          { ccode: "TM", cname: "Turkmenistan" },
          { ccode: "TC", cname: "Turks And Caicos Islands" },
          { ccode: "TV", cname: "Tuvalu" },
          { ccode: "UG", cname: "Uganda" },
          { ccode: "UA", cname: "Ukraine" },
          { ccode: "AE", cname: "United Arab Emirates" },
          { ccode: "GB", cname: "United Kingdom" },
          { ccode: "US", cname: "United States" },
          { ccode: "UM", cname: "United States Outlying Islands" },
          { ccode: "UY", cname: "Uruguay" },
          { ccode: "UZ", cname: "Uzbekistan" },
          { ccode: "VU", cname: "Vanuatu" },
          { ccode: "VE", cname: "Venezuela" },
          { ccode: "VN", cname: "Vietnam" },
          { ccode: "VG", cname: "Virgin Islands, British" },
          { ccode: "VI", cname: "Virgin Islands, U.S." },
          { ccode: "WF", cname: "Wallis And Futuna" },
          { ccode: "EH", cname: "Western Sahara" },
          { ccode: "YE", cname: "Yemen" },
          { ccode: "ZM", cname: "Zambia" },
          { ccode: "ZW", cname: "Zimbabwe" },
        ],
      },
      country: null,
      countriesPopover: false,
      number_state: null,
      pin: "",
      find: "",
      items: [],
      fields: [
        {
          key: "prefix",
          label: "Code",
          sortable: true,
          sortDirection: "desc",
          type: "text",
          class: "text-right",
        },
        {
          key: this.noflags ? "icon_hidden" : "icon",
          label: "",
          class: "text-right",
        },
        {
          key: "name",
          label: "Country",
          sortable: true,
          sortDirection: "desc",
          type: "text",
        },
      ],
    };
  },
  mounted() {
    this.countryItems();
    this.checkNumber(this.value);
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          for (var i = 0; i < this.items.length; i++) {
            if (newVal.length >= this.items[i].prefix.length) {
              if (newVal == this.items[i].prefix) {
                // EXCEPTIONS:
                let preferred = this.defaultOptions.preferredPrefix.find(
                  (obj) => obj.id == newVal
                );
                if (preferred) {
                  console.log("found a preferred", preferred);
                  this.country = this.items.find(
                    (obj) => obj.code == preferred.code
                  );
                } else {
                  this.country = this.items[i];
                }
                break;
              }
            }
          }
          this.checkNumber(newVal);
        }
      },
    },
    pinverified: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          console.log("watch:pinverified", newVal);
          this.pinerror_tooltip = false;
          // this.pin = "";
          // this.pinsent = false
        }
      },
    },
    required: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal === true) {
          this.number_state = false;
        }
      },
    },
    pinrequired: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal === true) {
          this.number_state = false;
        }
      },
    },
  },
  computed: {
    hashedMobile() {
      let num = this.value;
      if (num) {
        if (num.length > 4) {
          let masked =
            num.substring(0, num.length - 4).replace(/\d/g, "#") +
            num.substring(num.length - 4, num.length);
          return masked;
        }
      }
    },
  },
  methods: {
    countryItems() {
      let countries = getCountries();
      let preferred = [];
      for (var i = 0; i < countries.length; i++) {
        let preferredCountry = this.defaultOptions.preferredCountries.find(
          (obj) => obj.code == countries[i]
        );
        let countryName = this.defaultOptions.iso3166.find(
          (obj) => obj.ccode == countries[i]
        );
        if (!countryName) {
          countryName = "CountryName";
        } else {
          countryName = countryName.cname;
        }
        let item = {
          icon: "flag-icon flag-icon-" + countries[i].toLowerCase(),
          name: countryName,
          code: countries[i],
          prefix: "+" + getCountryCallingCode(countries[i]),
        };
        if (!preferredCountry) {
          this.items.push(item);
        } else {
          preferred.push(item);
        }
      }
      this.items.sort(dynamicSort("name"));

      for (
        var i = this.defaultOptions.preferredCountries.length - 1;
        i >= 0;
        i--
      ) {
        let item = preferred.find(
          (obj) => obj.code == this.defaultOptions.preferredCountries[i].code
        );
        item._rowVariant = "secondary";
        if (item) {
          this.items.unshift(item);
        }
      }
      this.country = preferred.find(
        (obj) => obj.code == this.defaultOptions.preferredCountries[0].code
      );
      let item = this.items.find((obj) => obj.code == this.country.code);
      if (item) {
        item._rowVariant = "primary";
      }
      /*   console.log(this.items) */
    },
    countrySelected(e) {
      if (e.length > 0) {
        this.country = e[0];

        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i]._rowVariant) {
            if (this.items[i]._rowVariant != "secondary") {
              // JUST CHECK IF ITS A DEFAULT ONE
              let item = this.defaultOptions.preferredCountries.find(
                (obj) => obj.code == this.items[i].code
              );
              if (item) {
                this.items[i]._rowVariant = "secondary";
              } else {
                delete this.items[i]._rowVariant;
              }
            }
          }
          if (this.items[i].code == this.country.code) {
            this.items[i]._rowVariant = "primary";
          }
        }

        this.$emit("input", "");
      }
      this.countriesPopover = false;
    },
    checkNumber(e) {
      if (!this.country) {
        return;
      }
      let number = null
      if (e) {
        number = parsePhoneNumberFromString(e, this.country.code);
      }
      if (number) {
        let item = this.items.find((obj) => obj.code == number.country);
        if (item) {
          this.country = item;
          this.$emit("input", number.number);
          if (number.isValid()) {
            if (this.number_state == true || this.number_state == false) {
              this.number_state = true;
            }
            this.$emit("valid-number", number);
          } else {
            this.$emit("valid-number", false);
          }
        }
      } else {
        this.$emit("valid-number", false);
      }
    },
    updateNumber(e) {
      this.checkNumber(e);
      this.$emit("input", e);
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 43
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    sendPIN() {
      this.$emit("sendPIN", this.value);
    },
    checkPIN() {
      this.$emit("checkPIN", this.value, this.pin);
    },
  },
};
</script>

<style>
</style>